export const hasErrorsResponse = (props?: any) => {
    return {
        ...props,
        hasErrors: true,
    };
};
